<template functional>
  <div>
    <template v-if="props.breakUp">
      {{ $options.displayBrokenUpAddress(props).first }}<br />
      {{ $options.displayBrokenUpAddress(props).second }}<br />
      {{ $options.displayBrokenUpAddress(props).third }}
    </template>
    <template v-else>{{ $options.displayAddress(props) }}</template>
  </div>
</template>
<script>
import gql from "fraql";
import addressFormat, { AddressFragment } from "@/utils/addressFormat";
const defaultAddress = {
  addressText: null,
  addressIndex: null,
  addressCity: null,
  addressCountry: null,
  addressHouse: null,
  addressBox: null,
  addressState: null
};

export default {
  name: "AppShowAddress",
  props: {
    address: {
      type: Object,
      default: () => defaultAddress
    },
    breakUp: {
      type: Boolean,
      default: false
    }
  },
  displayAddress(props) {
    const {
      addressText,
      addressIndex,
      addressCity,
      addressState,
      addressHouse,
      addressBox,
      addressCountry
    } = props.address;

    let countryName = addressCountry ?? null;
    if (typeof countryName === "object") {
      countryName = countryName?.name;
    }

    return addressFormat({
      address: addressText,
      index: addressIndex,
      city: addressCity,
      state: addressState,
      box: addressBox,
      houseNumber: addressHouse,
      country: countryName
    });
  },
  displayBrokenUpAddress(props) {
    const {
      addressText,
      addressIndex,
      addressCity,
      addressState,
      addressHouse,
      addressBox,
      addressCountry
    } = props.address;

    let countryName = addressCountry ?? null;
    if (typeof countryName === "object") {
      countryName = countryName?.name;
    }

    return {
      first: addressFormat({
        address: addressText,
        houseNumber: addressHouse,
        box: addressBox
      }),
      second: addressFormat({
        index: addressIndex,
        city: addressCity,
        state: addressState
      }),
      third: countryName
    };
  },
  fragments: {
    addressFields: gql`
      fragment _ on Address {
        ${AddressFragment}
      }
    `,
    contactAddressFields: gql`
      fragment _ on Contact {
        addressText
        addressIndex
        addressCity
        addressState
        addressHouse
        addressBox
        addressCountryId
        addressCountry @client {
          id
          name
        }
      }
    `
  }
};
</script>
